import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { api } from "../../utils/api";

export default function ResidentSetup() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");
  
  const query = new URLSearchParams(window.location.search);
  const token = query.get("token");

  const submit = async e => {
    e.preventDefault();
    if (password !== confirm) {
      setErrorMsg("Şifreler birbiriyle uyuşmuyor.");
      return;
    }
    if (password.length < 6) {
      setErrorMsg("Şifreniz en az 6 karakter olmalıdır.");
      return;
    }
    
    setStatus("loading");
    try {
      await api.post("/resident/setup-password", { token, password });
      setStatus("success");
    } catch (x) {
      setErrorMsg(x.response?.data?.detail || "İşlem başarısız oldu.");
      setStatus("error");
    }
  };

  if (!token) return <div className="loading" style={{padding: "50px", textAlign: "center"}}>Geçersiz veya süresi dolmuş bağlantı.</div>;

  if (status === "success") {
    return (
      <main className="login-shell" style={{background: "linear-gradient(180deg, #10b981 0%, #eef2f6 100%)", minHeight: "100vh", display: "flex"}}>
        <section className="login-form" style={{textAlign:"center", margin:"auto", padding: "40px", background: "white", borderRadius: "12px", boxShadow: "0 10px 25px rgba(0,0,0,0.1)"}}>
          <div className="icon success" style={{color:"#10b981", marginBottom:20, display: "flex", justifyContent: "center"}}><ShieldCheck size={48}/></div>
          <h2 style={{color: "#333", marginBottom: "10px"}}>Harika!</h2>
          <p style={{color: "#666", marginBottom: "20px"}}>Şifreniz başarıyla oluşturuldu. Artık sisteme giriş yapabilirsiniz.</p>
          <button className="primary full" onClick={()=>window.location.href="/sakin"} style={{marginTop:20, background:"#10b981", border: "none", padding: "12px 20px", color: "white", borderRadius: "8px", cursor: "pointer", width: "100%"}}>Giriş Sayfasına Git</button>
        </section>
      </main>
    );
  }

  return (
    <main className="login-shell" style={{background: "linear-gradient(180deg, #3b82f6 0%, #eef2f6 100%)", minHeight: "100vh", display: "flex"}}>
      <section className="login-form" style={{margin: "auto", background: "white", padding: "40px", borderRadius: "12px", boxShadow: "0 10px 25px rgba(0,0,0,0.1)", width: "100%", maxWidth: "400px"}}>
        <div className="form-inner">
          <span className="eyebrow" style={{color: "#3b82f6", fontSize: "12px", fontWeight: "bold", letterSpacing: "1px"}}>HESAP KURULUMU</span>
          <h2 style={{marginTop: "5px", marginBottom: "10px", color: "#333"}}>Şifrenizi Belirleyin</h2>
          <p className="muted" style={{color: "#666", fontSize: "14px", marginBottom: "20px"}}>Başkent Sitesi uygulamanız için lütfen güvenli bir şifre oluşturun.</p>
          
          <form onSubmit={submit} style={{display: "flex", flexDirection: "column", gap: "15px"}}>
            <label style={{display: "flex", flexDirection: "column", gap: "5px", fontSize: "14px", fontWeight: "500", color: "#444"}}>
              Yeni Şifre
              <input value={password} onChange={e=>setPassword(e.target.value)} type="password" required style={{padding: "10px", borderRadius: "6px", border: "1px solid #ccc"}}/>
            </label>
            <label style={{display: "flex", flexDirection: "column", gap: "5px", fontSize: "14px", fontWeight: "500", color: "#444"}}>
              Yeni Şifre (Tekrar)
              <input value={confirm} onChange={e=>setConfirm(e.target.value)} type="password" required style={{padding: "10px", borderRadius: "6px", border: "1px solid #ccc"}}/>
            </label>
            
            {errorMsg && <div className="error" style={{color:"red", fontSize:"13px", background: "#fee2e2", padding: "10px", borderRadius: "6px"}}>{errorMsg}</div>}
            
            <button className="primary full" disabled={status==="loading"} style={{background: "#3b82f6", border: "none", padding: "12px", color: "white", borderRadius: "8px", cursor: "pointer", fontWeight: "bold", marginTop: "10px"}}>
              {status === "loading" ? "Kaydediliyor..." : "Şifremi Kaydet"}
            </button>
          </form>
        </div>
      </section>
    </main>
  );
}